import { useContext } from 'react';
import { AuthContext } from '@context';

export const useAuthContext = () => {
  const context = useContext(AuthContext);
  return context;
};
